//import css Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
//se vogliamo bs customizzato
//import "../css/_bs5-custom.scss";

//import Font css
import "../css/fonts.css";
import "../css/_variable.css";

import "../css/_glightbox.css";
//import yii css
import "../css/_newsletterSubscription.css";
import "../css/_site.css";
import "../css/_header.css";
import "../css/_footer.css";
import "../css/_company.css";
import "../css/_contact.css";
import "../css/_home.css";
import "../css/_product.css";
import "../css/_news.css";
import "../css/_faq.css";
import "../css/_service.css";
//import form css
import "../css/_form.css";
//import shopify css
import "../css/_shopify.css";
import "../css/_shopifyUser.css";

// Import all of Bootstrap's JS
//import * as bootstrap from "bootstrap";
//import { Popover } from "bootstrap";

//import Modal from "bootstrap/js/dist/modal";

import ShopifyCart from "../js/ShopifyCart.js"; //NASCOSTO!!

import ShopifyUser from "../js//ShopifyUser.js";

//import JS SLIDER
import Slider from "../js/Slider.js";
//import NslSubscription
import NslSubscription from "../js/NslSubscription.js";
//import NslSubscription
import MenuToggle from "../js/menuToggle.js";
//import Popover
import { initVariantPopovers } from "../js/VarPopover.js";

MenuToggle.init();

//import GlightBox
import LightBox from "../js/Glightbox.js";

//import FAQ
import Faq from "../js/Faq.js";
Faq.init();

console.log("[webpack bundle js]");

document.addEventListener("DOMContentLoaded", () => {
  // Inizializza il carrello Shopify quando la pagina è pronta NASCOSTO
  /* ATTENZIONE il pulsante è nascosto anche tramite css .global-cart-container|#global-cart-toggle  */
  window.shopifyCart = new ShopifyCart();

  new ShopifyUser();

  //gestione modale newsletter
  NslSubscription.init();
});

//initialize Sliders
Slider.init();
//GLIGHTBOX
LightBox.init();

//POPOVER
initVariantPopovers();
